// extracted by mini-css-extract-plugin
export default {"body":"Layout_body__JvmfJ"};